<template>
    <span class="print-dropdown d-flex">
        <div :class="icon"></div>
        <arrow-collapse class="flex-fill">
            <template #trigger-label>
                <slot name="trigger-label"></slot>
            </template>
            <template #collapsed-content>
                <div class="dropdown-content">
                    <slot name="collapse-content"></slot>
                </div>                        
            </template>
        </arrow-collapse>
    </span>
</template>

<script>
    import ArrowCollapse from './ArrowCollapse'

    export default {
        components: {
            ArrowCollapse
        },
        props: {
            icon: {
                type: String,
                default: 'icon-printer'
            }
        },
        data() {
            return {
                showCollapsed: false,
                id: 'dropdown-'+Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
            }
        },
        methods: {},
        mounted() {
        }
    
}
</script>